import ButtonGlobal from '@shared/Button'
import { Col, Row, Space, Typography } from 'antd'
import React, { useCallback } from 'react'
import { DownloadBtnIco } from '@modules/CustomIcons'
import { BUTTONS } from 'constants/constants'
import { useTranslation } from 'react-i18next'
import UploadInput from '@shared/UploadInput'
import { useFetchEmployeeInfoExcel } from 'pages/Orders/SalaryCardOrder/models/useFetchEmployeeInfoExcel'
import { useFormContext, useFormState } from 'react-hook-form'
import useDownloadTemplate from '@shared/hooks/useDownloadTemplate'
import excelFile from '../../../../../../../../public/SalaryCardsOrderTemplate.xls'

function UploadEmployee({ type }: { type: 'create' | 'update' }) {
  const { resetField, getValues } = useFormContext()
  const { errors } = useFormState({ name: 'tableList', exact: true })

  const { mutate, status } = useFetchEmployeeInfoExcel()

  // const fields = errors?.tableList?.length || 0
  const formStatus =
    errors?.tableList && Array.isArray(errors?.tableList)
      ? errors?.tableList?.filter(
          (item) => item !== null && item !== undefined && item !== ''
        )?.length
      : 0

  const { t } = useTranslation()

  const onSend = useCallback((file) => {
    resetField('tableList')
    mutate(file[0])
  }, [])

  const downloadExcel = useDownloadTemplate(
    excelFile,
    'SalaryCardsOrderTemplate.xls'
  )

  return (
    <Row
      justify="space-between"
      align="middle"
      style={{ padding: '10px 20px 20px 20px', order: 1 }}
    >
      <Col span={12}>
        {type === 'create' && (
          <Row justify="start" gutter={16} align="middle">
            <Col span={10}>
              <Space>
                <ButtonGlobal
                  customType="default"
                  leftIcon={<DownloadBtnIco />}
                  onClick={downloadExcel}
                >
                  {BUTTONS.DOWNLOAD_PATTERN}
                </ButtonGlobal>
                <UploadInput
                  accept=".xls, .xlsx"
                  disabled={status === 'loading'}
                  onSend={onSend}
                />
              </Space>
            </Col>
          </Row>
        )}
      </Col>
      <Col span={12}>
        <Row justify="end" align="middle" gutter={16}>
          <Col>
            <span style={{ marginRight: 10 }}>
              {' '}
              {t('orders.salaryCardOrder.inputLabels.totalNumberOfLines')}
            </span>
            <Typography.Text
              style={{
                cursor: 'pointer',
                display: 'inline-block',
                color: '#015cd1',
                width: 32,
                height: 32, 
                lineHeight: 1.5715,
                padding: '4px 0',
                boxSizing: 'border-box',
                border: '1px solid #015cd1',
                borderRadius: '50%',
                textAlign: 'center'
              }}
            >
              {getValues('tableList')?.length}
            </Typography.Text>
          </Col>
          <Col>
            <span style={{ marginRight: 10 }}>
              {t('orders.salaryCardOrder.inputLabels.numberOfLinesWithErrors')}
            </span>
            <Typography.Text
              style={{
                cursor: 'pointer',
                display: 'inline-block',
                color: '#f3646c',
                width: 32,
                height: 32, 
                lineHeight: 1.5715,
                padding: '4px 0',
                boxSizing: 'border-box',
                border: '1px solid #f3646c',
                borderRadius: '50%',
                textAlign: 'center'
              }}
            >
              {formStatus}
            </Typography.Text>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default UploadEmployee
